import axios from "axios";
import { useNavigate } from "react-router-dom";
// Axios Interceptor Instance
const AxiosInstance = axios.create({
    baseURL: process.env.BASE_URL
});


const mappings = new Map([
    [ "rpcreateorder", "payments-rpcreateorder"],
    ["getevent", "events-getevent"],
    ["getcheckin", "events-getcheckin"],
    ["postcheckin", "events-postcheckin"],
    ["getschedule", "events-getschedule"],
    ["getsponsors", "events-getsponsors"],
    ["getpartners", "events-getpartners"],
    ["getspeakers", "events-getspeakers"],
    ["admin/createspeaker", "events-createspeaker"],
    ["admin/createevent", "events-createevent"],
    ["admin/createspeaker", "events-createspeaker"],
    ["admin/getevent", "events-geteventadmin"],
    ["admin/addschedule", "events-addschedule"],
    ["validatecoupon", "coupons-validatecoupon"],
    ["admin/getcoupons", "coupons-getcoupons"],
    ["admin/generatecoupon", "coupons-generatecoupon"],
    ["admin/savecoupons", "coupons-savecoupons"],
    ["createPaylink", "payments-createPaylink"],
    ["grpPaynow", "payments-grpPaynow"],
    ["grpPaynowInitiatePayment", "payments-grpPaynowInitiatePayment"],
    ["eventregistration", "registrations-eventregistration"],
    ["contactus", "registrations-contactus"],
    ["getticket", "registrations-getticket"],
    ["admin/getregistrationslist", "registrations-getregistrationslist"],
    ["getuserdetails", "registrations-getuserdetails"],
    ["admin/getgrouppaylist", "registrations-getgrouppaylist"],
    ["admin/gettransactionlist", "registrations-gettransactionlist"],
    ["generatepdf", "reportsw-generatePdfWithBase64Images"],
    ["admin/manageTracks", "tracks-manageTracks"],
    ["admin/listTemplates", "templates-listTemplates"],
    ["admin/getTemplate", "templates-getTemplate"],
    ["admin/saveTemplate", "templates-saveTemplate"],
    ["admin/createTemplate", "templates-createTemplate"],
    ["admin/manageSponsors", "sponsors-manageSponsors"],
    ["admin/managePartners", "partners-managePartners"],
    ["filedownload", "reportsw-reportStorage"],
    ["admin/resendEmail", "payments-resendEmail"],
    ["memberregistration", "registrations-memberregistration"],
    ["newslettersubscribe", "events-newslettersubscribe"],
    ["gettestimonials", "managetestimonials-gettestimonials"],
    ["admin/manageTestimonials", "managetestimonials-manageTestimonials"],
    ["getnews", "events-managenews"],
    ["admin/managenews", "events-managenews"],
    ["getblogs", "manageblogs-getBlogs"],
    ["admin/manageblogs", "manageblogs-manageBlogs"],
    ["admin/manageawards", "awards-manageAwards"],
    ["getawards", "awards-getAwards"],
    ["getgallery", "managegallery-getGallery"],
    ["admin/managegallery", "managegallery-manageGallery"],
    ["getaudienceexperience", "manageaudienceexperience-getAudienceExperience"],
    ["admin/manageAudienceExperience", "manageaudienceexperience-manageAudienceExperience"],
    ["getawardjury", "awardjury-getAwardJury"],
    ["admin/manageAwardJury", "awardjury-manageAwardJury"],
    ["getmediacoverage", "mediacoverage-getMediaCoverage"],
    ["admin/managemediacoverage", "mediacoverage-manageMediaCoverage"],
    ["admin/getPage", "additionalpages-getPage"],
    ["admin/savePage", "additionalpages-savePage"],
    ["admin/createPage", "additionalpages-createPage"],
    ["admin/listPages", "additionalpages-listPages"],
    ["admin/manageAdditionalPages", "additionalpages-manageAdditionalPages"],
    ["admin/deletePage", "additionalpages-deletePage"],
    ["getadditionalpages", "additionalpages-getAdditionalPages"],
    ["getpublicpage", "additionalpages-getPublicPage"],
  ]);
AxiosInstance.interceptors.request.use(
    (config) => {
        //const accessToken = JSON.parse(token);
        if(process.env.NODE_ENV == "development" && config.url.indexOf('/api/')>=0)
        {
            let tempurl = config.url.split('api/')[1];
            tempurl= tempurl.split('?')[0];
            let qryparam =config.url.split('?');
            let qryparamval = '';
            if(qryparam.length>1)
            {
                qryparamval='?'+qryparam[1];
            }
           console.log("Mapped URL:", tempurl,  mappings.get(tempurl));
            config.url="http://localhost:5001/eventsapp-20ad1/us-central1/" + mappings.get(tempurl)  + qryparamval;
        }
        return config;
    },
    (error) => {
        // Handle request errors here
        return Promise.reject(error);
    }
);

// Axios Interceptor: Response Method
AxiosInstance.interceptors.response.use(
    (response) => {
        // Can be modified response
        return response;
    },
    (error) => {
        // Handle response errors here
        return Promise.reject(error);
    }
);



const AxiosAdminInstance = axios.create({
    baseURL: process.env.BASE_URL
});
AxiosAdminInstance.interceptors.request.use(
    (config) => {
        let token = null;
        if(config.url.indexOf('/api/admin/')>=0)
        { token= sessionStorage.getItem('TOKEN_KEY');}
        //const accessToken = JSON.parse(token);
        if(process.env.NODE_ENV == "development" && config.url.indexOf('/api/')>=0)
        {
            let tempurl = config.url.split('api/')[1];
            tempurl= tempurl.split('?')[0];
            let qryparam =config.url.split('?');
            let qryparamval = '';
            if(qryparam.length>1)
            {
                qryparamval='?'+qryparam[1];
            }
           
            config.url="http://localhost:5001/eventsapp-20ad1/us-central1/" + mappings.get(tempurl)  + qryparamval;
        }
        // If token is present, add it to request's Authorization Header
        if (token) {
            if (config.headers) config.headers.Authorization = 'Bearer ' + token;
        }
        return config;
    },
    (error) => {
        // Handle request errors here
        return Promise.reject(error);
    }
);

// Axios Interceptor: Response Method
AxiosAdminInstance.interceptors.response.use(
    (response) => {
        // Can be modified response
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
        return window.location.href = '/weba/signin'
        }
        // Handle response errors here
        return Promise.reject(error);
    }
);

// Cache utility functions
const CACHE_EXPIRY_MINUTES = 10;

function setCache(key, data, expiryMinutes = CACHE_EXPIRY_MINUTES) {
    const cacheData = {
        data: data,
        timestamp: Date.now(),
        expiryMinutes: expiryMinutes
    };
    // Convert to JSON string and then base64 encode
    const jsonString = JSON.stringify(cacheData);
    const base64Data = btoa(unescape(encodeURIComponent(jsonString)));
    localStorage.setItem(key, base64Data);
}

function getCache(key) {
    const cachedData = localStorage.getItem(key);
    if (!cachedData) {
        return null;
    }

    try {
        // Decode base64 and parse JSON
        const jsonString = decodeURIComponent(escape(atob(cachedData)));
        const parsed = JSON.parse(jsonString);
        const now = Date.now();
        const expiryTime = parsed.timestamp + (parsed.expiryMinutes * 60 * 1000);

        if (now < expiryTime) {
            return parsed.data;
        } else {
            // Cache expired, remove it
            localStorage.removeItem(key);
            return null;
        }
    } catch (error) {
        console.error('Error parsing cached data:', error);
        localStorage.removeItem(key);
        return null;
    }
}

function clearCache(key) {
    localStorage.removeItem(key);
}

function clearAllCache() {
    localStorage.clear();
}

// Enhanced AxiosInstance with caching
const AxiosInstanceWithCache = {
    ...AxiosInstance,
    async get(url, config = {}) {
        // Only cache GET requests
        if (url.includes('/api/')) {
            const cacheKey = `api_cache_${url}`;
            const cachedData = getCache(cacheKey);
            
            if (cachedData) {
                return { data: cachedData, cached: true };
            }
        }

        try {
            const response = await AxiosInstance.get(url, config);
            
            // Cache successful GET responses
            if (url.includes('/api/') && response.data) {
                const cacheKey = `api_cache_${url}`;
                setCache(cacheKey, response.data);
            }
            
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export {AxiosInstance, AxiosAdminInstance, AxiosInstanceWithCache, setCache, getCache, clearCache, clearAllCache}
